<template>
  <ais-instant-search
    :search-client="searchClient"
    :index-name="indexName"
    :search-function="searchFunction"
    :routing="routing"
  >
    <ais-configure
      :analytics="false"
      :attributes-to-highlight.camel="[]"
      :attributes-to-retrieve.camel="companyAttributes"
      :remove-words-if-no-result.camel="'allOptional'"
      :hits-per-page.camel="24"
    />
    <company-wrapper
      :jobs-count="jobsCount"
      :popular-companies-heading="popularCompaniesHeading"
      :param-prop="params"
    />
  </ais-instant-search>
</template>

<script>
import getRouting from '../routing';
import {
  buildFiltersString,
  searchClient,
  softDeletedFilter,
  storeIndexes,
} from '../utils';

import CompanyWrapper from './CompanyWrapper.vue';

export default {
  name: 'CompanySearch',
  components: { CompanyWrapper },
  props: {
    popularCompaniesHeading: {
      type: String,
      default: '',
    },
    paramProp: {
      default: undefined,
    },
  },
  data() {
    const params = this.paramProp;
    const indexName = params['indexes']['company'];
    return {
      params: JSON.stringify(params),
      isLoading: true,
      companyAttributes: params['company_retrieve_fields'] ?? ['id', 'name', 'slug', 'thumbnail', 'jobs'],
      indexName,
      query: '',
      jobsCount: {},
      routing: getRouting({ indexName, params }),
    };
  },
  methods: {
    async getJobs(query) {
      const filters = [];

      if (query && !filters.length) {
        const filterString = await buildFiltersString(query);
        filters.push(filterString);
      }

      if (filters.length && query) {
        query = '';
      }

      if (!filters.length || !filters[0].includes(softDeletedFilter)) {
        filters.push(softDeletedFilter);
      }

      if (this.paramProp['job_filters'].includes('for_career_site')) {
        filters.push('for_career_site = false');
      }

      const response = await this.searchClient.search([
        {
          indexName: this.paramProp['indexes']['job'],
          params: {
            filters: filters.filter(filter => filter).join(' AND '),
            attributesToRetrieve: ['id'],
            attributesToHighlight: [],
            facets: ['company.id'],
            hitsPerPage: 100000,
          },
        },
      ]);

      const companyIdFacets = response.results[0]['facets']['company.id'] ?? [];
      if (JSON.stringify(this.jobsCount) !== JSON.stringify(companyIdFacets)) {
        this.jobsCount = companyIdFacets;
      }

      return response.results[0].hits;
    },
    async searchFunction(helper) {
      const queryInUrl = decodeURIComponent(
        new URL(window.location).searchParams.get('query') || '',
      ).trim();

      const query = helper.state?.query?.trim() ?? '';
      const filters = ['(__soft_deleted = 0)'];
      let page = helper.getPage();

      if (query) {
        const jobs = await this.getJobs(query);
        if (jobs.length) {
          filters.push('jobs IN [' + jobs.map(item => item.id) + ']');
        }
      }

      if (query === '' && Object.keys(this.jobsCount).length) {
        this.jobsCount = {};
      }

      helper.state.query = '';
      helper.state.filters = filters.filter(filter => filter).join(' AND ');

      if (query !== queryInUrl) {
        page = 0;
        helper.setPage(page);
      }

      helper.search();

      if (query && !helper.state.query) {
        helper.setQuery(query).setPage(page);
      }
    },
  },
  created() {
    storeIndexes(this.paramProp['indexes']);
  },
  computed: {
    searchClient() {
      return searchClient;
    },
  },
};
</script>
